import React from 'react';
import Grid from '@material-ui/core/Grid';
import ExpandingList3 from '../../ExpandingList/ExpandingList3';
import ExpandingList2 from '../../ExpandingList/ExpandingList2';

const ExtraCurricularActivities = ({ classes, version, form, setForm, disabled }) => (
  <Grid item xs={12} align="left">
    <Grid item xs={12}>
      <section align="left" className={classes.sectionTitle}>
        Extra-Curricular Activities
      </section>
      {version === 2 && (
        <div align="left" style={{ marginTop: -10, marginBottom: 10 }}>
          Please enter the school year, duration and give a brief description of any extracurricular activities that you are/were involved in.
        </div>
      )}
    </Grid>
    {version === 2 ? (
      <>
        <Grid container direction="row" className={classes.unprintedContent}>
          <Grid item xs={12}>
            <Grid container direction="row" className={classes.rowSpacer}>
              <Grid item xs={2} sm={2} md={2} lg={2} className={classes.rowSpacer}>
                <label>School Year</label>
              </Grid>
              <Grid item xs={3} sm={3} md={3} lg={3} className={classes.rowSpacer}>
                <label>Completed Season/Year Round Activity</label>
              </Grid>
              <Grid item xs={6} sm={6} md={6} lg={6} className={classes.rowSpacer}>
                <label>Activity & Description</label>
              </Grid>
            </Grid>
            <ExpandingList3
              className={classes.unprintedContent}
              form={form}
              setForm={setForm}
              listname="extraCurricularActivitiesV2"
              rowsRequired={1}
              disabled={disabled}
              field1="schoolYear"
              field1Cols={2}
              field1MaxLength={20}
              field2="completedSeasonOrYear"
              field2Cols={3}
              field2MaxLength={100}
              field3="activityAndDescription"
              field3Cols={6}
              field3MaxLength={255}
              inputHeight={36}
            />
          </Grid>
        </Grid>
        <Grid container direction="row" className={classes.printedContent}>
          <Grid item xs={12}>
            <Grid container direction="row" className={classes.rowSpacer}>
              <Grid item xs={4} sm={3} md={3} lg={3} className={classes.rowSpacer}>
                <label>School Year</label>
              </Grid>
              <Grid item xs={4} sm={3} md={3} lg={3} className={classes.rowSpacer}>
                <label>Completed Season/Year Round Activity</label>
              </Grid>
              <Grid item xs={4} sm={6} md={6} lg={6} className={classes.rowSpacer}>
                <label>Activity & Description</label>
              </Grid>
            </Grid>
            {(form?.extraCurricularActivitiesV2 ?? []).map((e, i) => (
              <Grid container direction="row" className={classes.rowSpacer} key={i}>
                <Grid item xs={4} sm={3} md={3} lg={3} className={classes.rowSpacer}>
                  {e.schoolYear}
                </Grid>
                <Grid item xs={4} sm={3} md={3} lg={3} className={classes.rowSpacer}>
                  {e.completedSeasonOrYear}
                </Grid>
                <Grid item xs={4} sm={6} md={6} lg={6} className={classes.rowSpacer}>
                  {e.activityAndDescription}
                </Grid>
              </Grid>
            ))}
          </Grid>
        </Grid>
      </>
    ) : (
      <>
        <Grid container direction="row" className={classes.unprintedContent}>
          <Grid item xs={12}>
            <Grid container direction="row" className={classes.rowSpacer}>
              <Grid item xs={6} sm={3} md={3} lg={3} className={classes.rowSpacer}>
                <label>School Year</label>
              </Grid>
              <Grid item xs={6} sm={6} md={6} lg={6} className={classes.rowSpacer}>
                <label>Activity</label>
              </Grid>
            </Grid>
            <ExpandingList2
              className={classes.unprintedContent}
              form={form}
              setForm={setForm}
              listname="extraCurricularActivites"
              rowsRequired={1}
              disabled={disabled}
              field1="schoolYear"
              field1Cols={3}
              field1MaxLength={100}
              field2="description"
              field2Cols={8}
              field2MaxLength={255}
              inputHeight={36}
            />
          </Grid>
        </Grid>
        <Grid container direction="row" className={classes.printedContent}>
          <Grid item xs={12}>
            <Grid container direction="row" className={classes.rowSpacer}>
              <Grid item xs={6} sm={3} md={3} lg={3} className={classes.rowSpacer}>
                <label>School Year</label>
              </Grid>
              <Grid item xs={6} sm={6} md={6} lg={6} className={classes.rowSpacer}>
                <label>Activity</label>
              </Grid>
            </Grid>
            {(form?.extraCurricularActivites ?? []).map((e, i) => (
              <Grid container direction="row" className={classes.rowSpacer} key={i}>
                <Grid item xs={6} sm={3} md={3} lg={3} className={classes.rowSpacer}>
                  <span data-testid={`schoolYear-${i}`}>{e.schoolYear}</span>
                </Grid>
                <Grid item xs={6} sm={6} md={6} lg={6} className={classes.rowSpacer}>
                  <span data-testid={`activity-${i}`}>{e.description}</span>
                </Grid>
              </Grid>
            ))}
          </Grid>
        </Grid>
      </>
    )}
  </Grid>
);

export default ExtraCurricularActivities;
